import React from 'react'
import { useTranslation } from 'react-i18next'

import TextInput from '../../../../../../App/Components/Form/TextInput/TextInput'

import style from './Style.scss'

type Props = {
  isMultiLine: boolean
}

export const OpenTypeField = ({ isMultiLine }: Props) => {
  const { t } = useTranslation()

  if (isMultiLine) {
    return (
      <textarea
        value={t('Long answer text')}
        placeholder={t('Long answer text')}
        className={style.textarea}
        readOnly
      />
    )
  }

  return (
    <TextInput
      type={'text'}
      value={t('Short answer text')}
      defaultText={t('Short answer text')}
      isReadOnly
    />
  )
}
